import { ExpandMore } from '@mui/icons-material'
import styled from 'styled-components'
import { COLORS } from 'utils'

export interface ExpandStyles {
  marginTop?: string
  marginBottom?: string
  marginLeft?: string
  marginRight?: string
  cursor?: string
  colorIcon?: string
  isExpanded: boolean
}

export const ExpandCustom = styled(ExpandMore)<ExpandStyles>`
  margin-top: ${({ marginTop }) => marginTop || '0'};
  margin-bottom: ${({ marginBottom }) => marginBottom || '0'};
  margin-left: ${({ marginLeft }) => marginLeft || '0'};
  margin-right: ${({ marginRight }) => marginRight || '0'};
  cursor: ${({ cursor }) => cursor || 'pointer'};
  color: ${({ colorIcon }) => colorIcon || COLORS.black};
  transform: ${({ isExpanded }) =>
    isExpanded ? 'rotate(0deg)' : 'rotate(180deg)'};
`
